export default "__VITE_ASSET__DF80DBdI__"